import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateSocialLinks } from './get-social-links'

export type RemoveSocialLinkRequest = {
  id: number
  buildingId: number
}

export const removeSocialLink = async (data: RemoveSocialLinkRequest): Promise<void> => {
  await authAPI.delete(`/sociallink/${data.id}`, {
    params: { buildingId: data.buildingId },
  })
}

export const useRemoveSocialLink = () => {
  const invalidate = useInvalidateSocialLinks()

  return useMutation({
    mutationFn: removeSocialLink,
    onSuccess: invalidate,
  })
}
